'use strict';
(function () {
  angular.module('pentaApp').factory('mercadoPagoByApi.resource', service);

  service.$inject = ['$resource'];
  function service($resource) {
    return $resource('/progressiveApp/api/mercadoPagoByApi', {}, {
      pay: {
        method: 'POST',
        isArray: false
      }
    });
  }

})();
